import { IMAGES } from "../content";
import { Reveal, MaskedReveal } from "../motion";
import { Section, Wrap, Eyebrow } from "./Section";

const BSM = ["Client relationship", "Discovery and strategy", "Branding and creative direction", "Messaging and content", "Project leadership"];
const SN = ["Digital strategy", "Solution architecture", "UX and interaction design", "Development and technical delivery", "Integrations and platform planning"];

export default function WhyUs() {
  return (
    <Section id="why" theme="neutral" className="py-16 sm:py-24 overflow-hidden">
      <Wrap>
        <Reveal>
          <Eyebrow>Why Blank Space Media</Eyebrow>
        </Reveal>
        <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-[3.4rem] leading-[1.1] tracking-tight mt-6 max-w-4xl text-[#242424]">
          <MaskedReveal lines={["The proof is not this page of claims.", "It is the page you have been reading."]} baseDelay={0.1} />
        </h2>
        <Reveal delay={2}>
          <p className="text-[#242424]/65 text-base sm:text-lg leading-relaxed mt-7 max-w-2xl">
            This proposal was built to the standard we intend for your platform, strategically, visually and around the people it must serve.
          </p>
        </Reveal>

        <div className="grid lg:grid-cols-12 gap-6 mt-10 sm:mt-12">
          <Reveal className="lg:col-span-5">
            <div className="bg-[#242424] text-[#F5F3EE] rounded-3xl p-8 sm:p-12 h-full">
              <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#FFD400]">Client-facing lead</p>
              <h3 className="font-serif text-3xl font-light mt-4">Blank Space Media</h3>
              <ul className="mt-8 space-y-3.5">
                {BSM.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-[#F5F3EE]/80">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#FFD400]" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={1} className="lg:col-span-4">
            <div className="bg-white border border-[#242424]/10 rounded-3xl p-8 sm:p-12 h-full">
              <p className="text-[10px] font-bold uppercase tracking-[0.24em] text-[#B66E50]">Supporting, behind the scenes</p>
              <h3 className="font-serif text-3xl font-light mt-4 text-[#242424]">StrateNova</h3>
              <ul className="mt-8 space-y-3.5">
                {SN.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-sm text-[#242424]/70">
                    <span className="w-1.5 h-1.5 rounded-full bg-[#6F806E]" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal delay={2} className="lg:col-span-3">
            <div className="relative rounded-3xl overflow-hidden h-64 lg:h-full group">
              <img
                src={IMAGES.conversation}
                alt="A warm, candid outdoor conversation in natural South African light"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
                loading="lazy"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0F0F0F]/85 to-transparent p-6">
                <p className="font-serif italic text-lg text-[#F5F3EE] leading-snug">
                  “They already understand what we are trying to become.”
                </p>
                <p className="text-[9px] font-bold uppercase tracking-[0.2em] text-[#F5F3EE]/60 mt-3">The reaction this proposal is designed for</p>
              </div>
            </div>
          </Reveal>
        </div>
      </Wrap>
    </Section>
  );
}
